<template>
  <v-container>
      <v-layout row wrap>
        <v-flex xs12 class="pa-3">
           <h1>PlayPosit Manage Link</h1>
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex xs12 sm6 class="px-3">
          <h2 color="white">Details</h2>
          <v-divider color="white"></v-divider>
          <v-layout class="py-3">
            <v-flex xs5 sm4 ><strong>Status:</strong></v-flex>
            <v-flex xs7 sm7 offest-sm1>Linked</v-flex>
          </v-layout>
          <v-layout class="py-3">
            <v-flex xs5 sm4 ><strong>Bulb ID:</strong></v-flex>
            <v-flex xs7 sm7 offest-sm1>{{LTIdata.contentId}}</v-flex>
          </v-layout>              
          <v-layout class="py-3">
            <v-flex xs5 sm4 ><strong>Bulb Name:</strong></v-flex>
            <v-flex xs7 sm7 offest-sm1>{{LTIdata.contentName}}</v-flex>
          </v-layout>             
          <v-layout class="py-3">
            <v-flex xs5 sm4 ><strong>Resource Link:</strong></v-flex>
            <v-flex xs7 sm7 offest-sm1 resourceName>{{resourceLinkName}}</v-flex>
          </v-layout>             
          <v-layout class="py-3">
            <v-flex xs5 sm4 ><strong>Class Name:</strong></v-flex>
            <v-flex xs7 sm7 offest-sm1>{{LTIdata.sectionName}}</v-flex>
          </v-layout>             
          <v-layout class="py-3">
            <v-flex xs5 sm4 ><strong>Tags:</strong></v-flex>
            <v-flex xs7 sm7 offest-sm1>{{LTIdata.bulbTags}}</v-flex>
          </v-layout>
          <!-- add this back in later -->
          <!--<v-layout class="py-3">-->
          <!--  <v-flex xs4 ><strong>Location:</strong></v-flex>-->
          <!--  <v-flex xs7 offest-xs1></v-flex>-->
          <!--</v-layout>-->
        </v-flex>
        <v-flex xs12 sm6 class="px-3">
          <h2 color="white">Actions</h2>
          <v-divider color="white"></v-divider>
          <v-layout class="py-3">
            <v-flex x5><strong>Bulb Preview</strong></v-flex>
            <v-flex xs7 offest-sm1><v-btn text @click="preview" color="white"  :disabled="loading">Preview</v-btn></v-flex>
          </v-layout>
          <v-layout class="py-3">
            <v-flex xs5><strong>Section Management</strong></v-flex>
            <v-flex xs7 offest-sm1><v-btn text @click="monitor" color="white" :disabled="loading">Monitor</v-btn></v-flex>
          </v-layout>
          <v-layout class="py-3">
            <v-flex x5><strong>Section Analytics</strong></v-flex>
            <v-flex xs7 offest-sm1><v-btn text @click="exportDataTable({type: 'Interactions', bulb_id: LTIdata.contentId, section_id: LTIdata.section_id})" color="white" :disabled="loading">CSV Download</v-btn></v-flex>
          </v-layout>
          <v-layout class="py-3">
            <v-flex x5 ><strong>PlayPosit Dashboard</strong></v-flex>
            <v-flex xs7 offest-sm1><v-btn text @click="enterPlayPosit" color="white" :disabled="loading">Enter PlayPosit</v-btn></v-flex>
          </v-layout>
          <v-layout class="py-3">
            <v-flex x5 >
              <strong>Live Session</strong>
            </v-flex>
            <v-flex xs7 offest-sm1>
              <v-switch
                dark
                v-model="enableLiveSession"
                label="Enable synchronous/live start time"
                hide-details
                height="30"></v-switch>
            </v-flex>
          </v-layout>
          <v-layout
            v-if="enableLiveSession"
            class="py-3"
            id="liveSessionLayout">
            <el-date-picker
              v-model="sessionStartTime"
              type="datetime"
              placeholder="Session start time"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
              @change="handleAddSessionStartTime"
              >
            </el-date-picker>
          </v-layout>
          <v-layout class="py-3" v-if="instructorData.isAdmin === 1">
            <v-flex x5><strong>Unlink Bulb</strong></v-flex>
            <v-flex xs7 offest-sm1><v-btn text @click="setDashModal({ type: 'confirmUnlink' })" color="primary" :disabled="loading" class="unlink-bulb">Unlink Bulb</v-btn></v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
      <v-layout row wrap v-if='instructorData.isAdmin === 1'>
        <BulbAssignments :bulbId="LTIdata.contentId" :admin="instructorData.isAdmin === 1" :dark="true" :embedded="true" :hideLtiLaunch="true"></BulbAssignments>
      </v-layout>
  </v-container>
</template>

<script>
  import _ from 'lodash'
  import { mapState, mapGetters, mapActions, mapMutations } from 'vuex';
  import BulbAssignments from './BulbAssignments';
  export default {
    name: 'ManageLTI',
    components: {
      BulbAssignments
    },
    data() {
      return {
        bulbSection: null,
        enableLiveSession: false,
        loading: false,
        sessionStartTime: null,
      }
    },
    props: [ ],
    computed: {
      ...mapGetters([
        'LTIdata',
        'LTIlaunch',
        'instructorData',
        'nodeApiPrefix',
      ]),
      formattedSessionStartTime() {
        return moment.tz(this.sessionStartTime, this.instructorData.timezone).utc().format('YYYY-MM-DD HH:mm:ss');
      },
      resourceLinkName() {
        return decodeURIComponent(_.get(this.LTIdata, 'resourceLinkName', '').replace(`${this.LTIdata.sectionName}:`, ''))
      },
    },
    methods: {
      ...mapMutations([
        'setDashModal',
        'setGreyscreen',
        'setNav',
        'simpleDashToggle',
        'stateDataLoadedToggle',
        'triggerSnackbar',
        'updateBreadCrumbs',
      ]),
      ...mapActions('instructors', [
        'addSessionStartTime',
        'exportDataTable',
        'getBulbSection',
        'getTableData',
        'updateUrl',
      ]),
      ...mapMutations('instructors', [
        'resetQueryParams',
        'setActiveView',
        'setGradebookBreadcrumbs',
        'setQueryParams',
      ]),
      enterPlayPosit() {
        this.simpleDashToggle({ activate: false });
        this.stateDataLoadedToggle();
        this.setGreyscreen(null);
      },
      async handleAddSessionStartTime() {
        try {
          await this.addSessionStartTime({
            bulbId: this.LTIdata.contentId,
            sectionId: this.LTIdata.section_id,
            sessionStartTime: this.formattedSessionStartTime,
          });
          this.triggerSnackbar({
            text: 'Updated sessionStartTime!',
            color: 'success',
            timeout: 6000,
          });
        } catch(e) {
          this.triggerSnackbar({
            text: 'Trouble setting session start time.',
            color: 'warning',
            timeout: 6000,
          });
          this.sessionStartTime = _.get(this.bulbSection, 'sessionStartTime', false) ? this.bulbSection.sessionStartTime : null;
        }
      },
      monitor() {
        this.setNav(['Classes', 'instructor']);
        this.resetQueryParams();
        let queryParams = {
          bulb_id: this.LTIdata.render_path !== 'playlist' ? this.LTIdata.contentId : '',  // 
          contentId: this.LTIdata.contentId,
          section_id: this.LTIdata.render_path !== 'playlist' ? this.LTIdata.section_id : this.LTIdata.contentSectionId, // [ ] playlist.sectionId, 
          lms_class: true,
        };
        this.setQueryParams(queryParams);
        //check render path to determine monitor page
        if (this.LTIdata.render_path === 'play2' || this.LTIdata.render_path === 'broadcast2' ) {
          this.setActiveView(['Interactions']);
        } else if (this.LTIdata.render_path === 'studentmade2') {
          if (this.LTIdata.peer_review == 'true') {
            this.setActiveView(['Peer-Review']);
          } else {
            this.setActiveView(['Learner-Made-Bulb']);
          }
        } else if (this.LTIdata.render_path === 'playlist') {
          this.setActiveView(['Gradebook']);
        }

        //breadcrumbs
        let payload = {};
        let breadcrumb = [
          { text: 'Classes', disabled: false, payload: 'Classes' }, 
          { text: this.LTIdata.sectionName, payload: '' }, 
          { text: 'My Bulbs', payload: 'My-Bulbs' }
        ];
        this.updateBreadCrumbs([breadcrumb, payload]);
        this.setGradebookBreadcrumbs([{text:this.LTIdata.contentName, payload: ''}])
        //get table data, update url
        this.getTableData()
        this.updateUrl();
        
        setTimeout(() => {
          let url = `${window.location.href}&monitor=true`
          window.open(url);
        }, 1000);
      },
      preview() {
        let url = `${this.nodeApiPrefix}/player_v2/?type=share&bulb_id=${this.LTIdata.contentId}&token=${this.instructorData.token}&section_id=${this.LTIdata.section_id}&lms_launch=${this.LTIlaunch}`;
        window.open(url);
      },
    },
    watch: {
      'bulbSection' () {
        if (_.get(this.bulbSection, 'sessionStartTime', false)) {
          this.enableLiveSession = true;
          this.sessionStartTime = moment.tz(this.bulbSection.sessionStartTime).format("YYYY-MM-DD hh:mm:ss");
        }
      },
      'enableLiveSession'(n, o) {
        // enable live session is false but used to be true - set sessionStartTime to null
        if (!n && o) {
          this.sessionStartTime = null;
          this.handleAddSessionStartTime();
        }
      },
    },
    async mounted() {
      this.bulbSection = await this.getBulbSection({
        bulbId: this.LTIdata.contentId,
        sectionId: this.LTIdata.section_id,
      });
    },
  }
    
</script>

<style >
  #greyscreen .v-btn__content {
    color: var(--branding-active-hex) !important;
  }
  
  #greyscreen .unlink-bulb div {
    color: #fff !important;
  }
  
  resourceName {
    width: 80%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  #liveSessionLayout .el-date-editor.el-input {
    width: 100%;
  }
</style>